<template>
    <div>
        <vs-button
            @click="activeAgregar =!activeAgregar"
            success
            class="ml-auto mt-4"
        >
            <i class="fas fa-plus mr-2"></i> Agregar nueva configuración
        </vs-button>
        <crear v-model="activeAgregar" :institucion="institucion" :cicloEscolar="cicloEscolar" :programa="programa" @refreshTable="getFiltros"></crear>
        <editar v-model="activeEditar" :institucion="institucion" :cicloEscolar="cicloEscolar"  :row="selectedRow" @refreshTable="getFiltros"></editar>
        <eliminar v-model="activeEliminar" :row="selectedRow" @refreshTable="getFiltros"></eliminar>
        
        <vs-alert v-if="alerta === true">
            <template #title>
                No se encontró información
            </template>
            Te sugerimos agregar una nueva configuración
        </vs-alert>
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th >
                    Información
                </vs-th>
                <vs-th >
                    Habilitadas
                </vs-th>
                <vs-th >
                    No habilitadas
                </vs-th>
                <vs-th>
                    Fecha
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
            >
                <vs-td v-if="tr != null">
                    <p><strong>{{tr.nombre}}</strong></p>
                    <p>{{tr.institucion}}</p>
                    <p>{{tr.ciclo_escolar}}</p>
                    <p>{{tr.programa}}</p>
                    <p><i>Componente académico:</i> {{tr.nombre_componente}}</p>
                    <p><i>Detalle componente académico:</i> {{tr.nombre_detalle}}</p>
                    <p><i>Modo de captura:</i> {{tr.modo_captura}}</p>
                </vs-td>
                <vs-td v-if="tr != null">
                    <md-chip v-if="tr.calificacion === 'si'" class="mini-chip col-yellow mx-0 mb-1" ><strong>Calificación</strong></md-chip>
                    <md-chip v-if="tr.faltas === 'si'" class="mini-chip col-red mx-0 mb-1" ><strong>Faltas</strong></md-chip>
                    <md-chip v-if="tr.retardos === 'si'" class="mini-chip col-green mx-0 mb-1" ><strong>Retardos</strong></md-chip>
                    <md-chip v-if="tr.conducta === 'si'" class="mini-chip col-purple mx-0 mb-1" ><strong>Conducta</strong></md-chip>
                    <md-chip v-if="tr.tareas_no_hechas === 'si'" class="mini-chip col-blue mx-0 mb-1" ><strong>Tareas no hechas</strong></md-chip>
                    <md-chip v-if="tr.activo_boleta === 'si'" class="mini-chip col-gray mx-0 mb-1" ><strong>Boleta activa</strong></md-chip>
                    <md-chip v-if="tr.mostrar_acta === 'si'" class="mini-chip col-pink mx-0 mb-1" ><strong>Monstrar acta</strong></md-chip>
                </vs-td>
                <vs-td v-if="tr != null">
                    <md-chip v-if="tr.calificacion === 'no'" class="mini-chip col-yellow mx-0 mb-1" ><strong>Calificación</strong></md-chip>
                    <md-chip v-if="tr.faltas === 'no'" class="mini-chip col-red mx-0 mb-1" ><strong>Faltas</strong></md-chip>
                    <md-chip v-if="tr.retardos === 'no'" class="mini-chip col-green mx-0 mb-1" ><strong>Retardos</strong></md-chip>
                    <md-chip v-if="tr.conducta === 'no'" class="mini-chip col-purple mx-0 mb-1" ><strong>Conducta</strong></md-chip>
                    <md-chip v-if="tr.tareas_no_hechas === 'no'" class="mini-chip col-blue mx-0 mb-1" ><strong>Tareas no hechas</strong></md-chip>
                    <md-chip v-if="tr.activo_boleta === 'no'" class="mini-chip col-gray mx-0 mb-1" ><strong>Boleta activa</strong></md-chip>
                    <md-chip v-if="tr.mostrar_acta === 'no'" class="mini-chip col-pink mx-0 mb-1" ><strong>Monstrar acta</strong></md-chip>
                </vs-td>
                <vs-td v-if="tr != null">
                    <p class="mb-0"><strong>Captura</strong></p>
                    <p class="mb-0">Fecha de inicio: <i>{{ tr.fecha_inicio_captura }}</i></p>
                    <p>Hora de inicio: <i>{{ tr.hora_inicio_captura }} hrs</i></p>
                    <p class="mb-0">Fecha final: <i>{{ tr.fecha_fin_captura }}</i></p>
                    <p>Hora final: <i>{{ tr.hora_fin_captura }} hrs</i></p>
                    <p class="mb-0"><strong>Periodo</strong></p>
                    <p class="mb-0">Fecha de inicio: <i>{{ tr.fecha_inicio_periodo }}</i></p>
                    <p class="mb-0">Fecha final: <i>{{ tr.fecha_fin_periodo }} hrs</i></p>
                </vs-td>
                <vs-td v-if="tr != null">
                    <md-menu md-size="small"  md-align-trigger>
                        <md-button class="md-icon-button" md-menu-trigger>
                            <i class="fas fa-ellipsis-v"></i>
                        </md-button>

                        <md-menu-content>
                            <md-menu-item @click="activeEditar = !activeEditar;  selectedRow = tr;">
                                Editar
                            </md-menu-item>
                            <md-menu-item @click="activeEliminar = !activeEliminar;  selectedRow = tr;">
                                Eliminar
                            </md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </vs-td>
            </vs-tr>
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
            <template #notFound>
                No hay información
            </template>

        </vs-table>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
import eliminar from './modal/eliminar.vue'
import academico from '../../../../api/requests/academico.js'
import crear from './modal/crear.vue'
export default {
    props:[
        'institucion',
        'cicloEscolar',
        'programa',
        'counter'
    ],
    data(){
        return{
            instituciones: [],
            institucionId: (new Date()).getTime(),
            errorInstituto: false,
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            errorCiclo: false,
            listPrograma: [],
            programasId:(new Date()).getTime(),
            errorPrograma: false,
            habilitadas: [],
            activeEditar: false,
            activeEliminar: false,
            selectedRow: [],
            page: 1, 
            max: 10,
            pages: 0,
            users: [],
            activeAgregar: false,
            alerta: false
        }
    },
    components:{
        editar,
        eliminar,
        crear
    },
    methods:{
        async getFiltros(){
                if(this.programa == ''){
                    this.errorPrograma = true
                }else{
                    this.errorPrograma = false
                }

                if(this.institucion == ''){
                    this.errorInstituto = true
                }else{
                    this.errorInstituto = false
                }

                if(this.cicloEscolar == ''){
                    this.errorCiclo = true
                }else{
                    this.errorCiclo = false
                }

                if(this.programa == '' || this.institucion == '' || this.cicloEscolar == ''){
                    return false
                }
        const loading = this.$vs.loading()
            try {
                let params = {
                    ciclo_escolar: this.cicloEscolar,
                    institucion: this.institucion,
                    programa: this.programa,
                    page: this.page || 1,
                    size: this.max || 20,
                }
                const {data: response} = await academico.getFiltros(params)
                const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = dataTable
                loading.close()
                if(!response.data[0]){
                    this.alerta = true
                }else{
                    this.alerta = false
                }
            } catch (error) {
                
            }
        }
    },
    watch:{
        page(){
            this.getFiltros()
        },
        counter(){
            this.users = []
            this.getFiltros()
            this.$emit('refreshTable')
        }
        
    }
}
</script>

<style scoped>
    .objetfitcover > img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 15px;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .mini-chip{
        width: 100% !important;
        text-align: center !important;
        height: 24px;
        line-height: 24px;
    }
</style>

        